import React from "react";
import { Chip, ChipProps } from "@mui/material";
import { GENRE_LABELS, Genre } from "../../types";

interface GenreChipProps {
  genre: string;
  size?: ChipProps["size"];
  sx?: ChipProps["sx"];
}

const GenreChip: React.FC<GenreChipProps> = ({ genre, size = "small", sx }) => {
  if (!genre) return null;

  return (
    <Chip label={GENRE_LABELS[genre as Genre] || genre} size={size} variant="outlined" sx={sx} />
  );
};

export default GenreChip;
